import { type FC } from "react";
import { type WorkContentAlbum } from "@clientFrontend/features/publication/type/type";
import { type OptionProps } from "@root/shared/components/SelectBox";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { AlbumCassette } from "./uiParts/AlbumCassette";
import * as styles from "./styles.css";

type Props = {
  selectedWorkContentAlbums: WorkContentAlbum[];
  albumCategoryOptions: OptionProps[];
  handleChangeAlbumSortNo: (currentSortNo: number, swapSortNo: number) => void;
  handleChangeAlbumCategory: (albumCategoryId: number, clientImageId: number) => void;
};

export const Presentation: FC<Props> = ({
  selectedWorkContentAlbums,
  albumCategoryOptions,
  handleChangeAlbumSortNo,
  handleChangeAlbumCategory,
}) => {
  return (
    <div className={styles.cassetteWrap}>
      {selectedWorkContentAlbums.map((workContentAlbum, index) => (
        <div key={workContentAlbum.clientImageId}>
          <AlbumCassette
            index={index}
            workContentAlbum={workContentAlbum}
            albumCategoryOptions={albumCategoryOptions}
            selectedWorkContentAlbumsCount={selectedWorkContentAlbums.length}
            handleChangeAlbumSortNo={handleChangeAlbumSortNo}
            handleChangeAlbumCategory={handleChangeAlbumCategory}
          />
        </div>
      ))}
      {Array.from({ length: 3 - selectedWorkContentAlbums.length }, (_, index) => (
        <div
          className={styles.noImageBox}
          key={`no-image-placeholder-${selectedWorkContentAlbums.length + index}`}
        >
          <LazyLoadImage
            src="/images/client_frontend/image_mockup.svg"
            alt="基本画像(ダミー)"
            height={122}
            width={216}
          />
        </div>
      ))}
    </div>
  );
};
